import React from "react";
import PropTypes from "prop-types";
import { downloadDiagnostics, reportError } from "utils/diagnostics";

export default class DiagnosticBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    reportError("react.render", error);
  }

  render() {
    const { failed } = this.state;
    const { children } = this.props;
    if (failed) {
      return (
        <main style={{ margin: "3rem", fontFamily: "sans-serif" }}>
          <h1>MegaPortal could not display this page.</h1>
          <p>Download diagnostics to share with support, then reload the page.</p>
          <button type="button" onClick={downloadDiagnostics}>
            Download diagnostics
          </button>{" "}
          <button type="button" onClick={() => window.location.reload()}>
            Reload
          </button>
        </main>
      );
    }
    return children;
  }
}

DiagnosticBoundary.propTypes = {
  children: PropTypes.node,
};
